export const registerFontFace = (data: string): void => {
  const newStyle = document.createElement('style');
  newStyle.appendChild(document.createTextNode(data));
  document.head.appendChild(newStyle);
};
